// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3041170","422":"e9d8bdf5","667":"57dd108b"}[chunkId] + ".chunk.js";
};